export const getMetricName = () => {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get('applicationSource') ?? 'default'
}
